<template>
  <div>
    <el-date-picker
      v-model="payDate"
      type="daterange"
      size="small"
      :start-placeholder="$t('Date from')"
      :end-placeholder="$t('Date to')"
      format="dd.MM.yyyy"
      value-format="yyyy-MM-dd"
      @change="fetchPayments"
    >
    </el-date-picker>
    <el-table
      :data="payments"
      class="orders-table"
      v-loading="loading"
      :default-sort = "{prop: 'pay_date', order: 'descending'}"
      @sort-change="sort">
      <el-table-column sortable="custom" min-width="150" prop="pay_date" :label="$t('Date')">
      </el-table-column>
      <el-table-column sortable="custom" min-width="150" prop="agrm_num" :label="$t('Agreement')">
      </el-table-column>
      <el-table-column sortable="custom" prop="amount" min-width="200" :label="$t('Sum')">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.amount) + ' ' + scope.row.cur_symb }}
        </template>
      </el-table-column>
      <div slot="empty" v-if="!payments">
        {{ $t('No payments')}}
      </div>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pgnum"
      :page-sizes="pageSizes"
      :page-size="pgsize"
      layout="prev, pager, next, ->, sizes, total"
      :total="total"
      class="orders-pagination">
    </el-pagination>
    <iframe id="hiddenDownloader" src="" />
  </div>
</template>

<script>
import { Table, TableColumn, Pagination, Button, DatePicker } from 'element-ui'
import axios from 'axios'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import number from './mixins/number'

locale.use(lang)

export default {
  name: 'PaymentsTable',
  mixins: [number],
  data () {
    return {
      payments: null,
      payDate: '',
      pageSizes: [10, 20, 30, 40, 50, 100],
      pgnum: 1,
      pgsize: 10,
      error: '',
      loading: false,
      total: 0,
      sortColumn: 'pay_date',
      sortOrder: 'desc'
    }
  },
  created () {
    this.fetchPayments()
  },
  methods: {
    handleSizeChange(val) {
      this.pgnum = 1
      this.pgsize = val
      this.fetchPayments()
    },
    handleCurrentChange(val) {
      this.pgnum = val
      this.fetchPayments()
    },
    fetchPayments() {
      this.loading = true
      axios.get('payments', {
        params: {
          uid: this.uid,
          pgnum: this.pgnum,
          pgsize: this.pgsize,
          payDate: this.payDate,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder
        }
      }).then(promise => {
        this.payments = promise.data.results
        this.total = promise.data.total
        this.loading = false
      }).catch(error => {
        console.log(error.response.data.error)
      })
    },
    sort(param) {
      if (param.column !== null) {
        this.sortColumn = param.prop
        this.sortOrder = param.order === 'descending' ? 'desc' : 'asc'
      } else {
        this.sortColumn = 'pay_date'
        this.sortOrder = 'desc'
      }
      this.fetchPayments()
    }
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [DatePicker.name]: DatePicker
  }
}

</script>

<style scoped>
  #hiddenDownloader {
    display: none
  }
  .orders-table {
    margin-bottom: 10px;
  }
  .orders-pagination >>> .el-input__inner {
    margin: 0 !important;
  }
  .orders-pagination >>> .el-input {
    width: 140px !important;
  }
</style>
